import { API_SERVICE } from '@/services/api.service';

/**
 * @deprecated Use API_SERVICE.request() instead
 * This function is kept for backward compatibility
 */
export async function capacitorRequest(config) {
    // capacitorRequest is deprecated. Use API_SERVICE.request() instead.
    return API_SERVICE.request(config);
}

/**
 * Helper function to build full URL for API requests
 */
export function buildApiUrl(path, config) {
    // Ensure the URL is absolute for native platforms
    if (!path.startsWith('http')) {
        return `${config.baseURL}${path}`;
    }
    return path;
}